import { render } from "./Declaration.vue?vue&type=template&id=5a324d7b&scoped=true"
import script from "./Declaration.vue?vue&type=script&lang=js"
export * from "./Declaration.vue?vue&type=script&lang=js"

import "./Declaration.vue?vue&type=style&index=0&id=5a324d7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a324d7b"]])

export default __exports__